import { render } from "./cwc_growth.vue?vue&type=template&id=4b33f067&scoped=true"
import script from "./cwc_growth.vue?vue&type=script&lang=js"
export * from "./cwc_growth.vue?vue&type=script&lang=js"

import "./cwc_growth.vue?vue&type=style&index=0&id=4b33f067&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b33f067"]])

export default __exports__